import axios from '@/libs/api.request'

export const getGoodsList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/goods'
  })
}

export const getGoodsClassification = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/goods/classification'
  })
}

export const addGoods = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/goods'
  })
}

export const editGoods = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/goods'
  })
}

export const delGoods = (id) => {
  return axios.request({
    method: 'delete',
    url: '/goods/' + id
  })
}

export const getGoodsInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/goods/' + id
  })
}

// 开启/关闭首充项
export const changeFirstCharge = (id) => {
  return axios.request({
    method: 'put',
    url: '/goods/firstCharge/' + id
  })
}

// 开启/关闭首充项
export const changeStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/goods/status/' + id
  })
}


export const check = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/goods/window'
  })
}

export const getBatch = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/goods/batch'
  })
}

